import React, { Component } from 'react';
import { connect } from 'react-redux';
import { smsCreationPending } from '../../../../reducers/auth';
import { clearSms } from '../../../../reducers/sendSmsStatus';
import { trackEvent, EVENTS } from '../../../../tracking/tracking';
import { createVirtualMember } from '../../../../reducers/authVirtualMember';
import {
  getVirtualMemberDetails,
  isVirtualMemberPending,
  didVirtualMemberFail,
  isVirtualMemberSuccess
} from '../../../../reducers/authVirtualMember';
import Button from '../../../Button';
import Title from '../../../Title';
import Spinner from '../../../Spinner';
import { RegularError, SmallError } from '../../../InputError';

const PHONE_STATUS = {
  VALID: 'VALID',
  INVALID: 'INVALID',
  NOT_FETCHED: 'NOT_FETCHED'
};

class PhoneStep extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // membershipPlan: this.props.summary.get('membershipPlan', this.props.userDetails.data.get('membershipPlan', '')),
      // servicesPolicy: this.props.summary.get('servicesPolicy', this.props.userDetails.data.get('servicesPolicy', '')),
      // privacyPolicy: this.props.summary.get('privacyPolicy', this.props.userDetails.data.get('privacyPolicy', '')),
      servicesPolicy: this.props.summary.get('servicesPolicy'),
      privacyPolicy: this.props.summary.get('privacyPolicy'),
      completed: false,
      validPhone: PHONE_STATUS.NOT_FETCHED,
      invalidPhone: false
    };
    this.props.clearSms();
    this.continue = this.continue.bind(this);
    this.setPhone = this.setPhone.bind(this);
  }

  componentDidUpdate() {
    if (this.props.isVirtualMemberSuccess) {
      this.props.next();
    }
    const invalid = this.props.smsStatus.validPhone === PHONE_STATUS.INVALID;
    const valid = this.props.smsStatus.validPhone === PHONE_STATUS.VALID && this.state.loading;
    if ((valid || invalid) && this.state.loading) {
      this.setState({ loading: false });
    }
  }

  continue(event) {
    trackEvent(EVENTS.ENTER_PHONE_CLICKED, { phoneNumber: this.state.phoneNumber });
    event.preventDefault();
    this.setState({ completed: true });
    const phone = this.state.phoneNumber;
    const phoneValidation = /^[+|0][0-9]{1,15}$/;
    let userData = this.props.virtualMemberDetails;
    if (phoneValidation.test(phone)) {
      this.props.createVirtualMember(this.state.phoneNumber);
      this.setState({ loading: true });
      this.props.updateSummary(userData.set('phoneNumber', this.state.phoneNumber));
    } else {
      this.setState({ invalidPhone: true });
    }
  }

  setPhone(event) {
    const phoneNumber = event.target.value;
    this.setState({
      phoneNumber,
      invalidPhone: false
    });
    if (this.props.smsStatus.validPhone === PHONE_STATUS.INVALID) {
      this.props.clearSms();
      let userData = this.props.userDetails.data;
      userData = userData.set('phoneNumber', '');
      this.props.updateSummary(userData);
    }
  }

  render() {
    const i18n = this.props.lang.i18n;
    const errorStatus = this.props.smsStatus.data.get('response', {}).status;
    const serverError = errorStatus > 499 ? 'phone-step__error' : 'phone-step__error-none';
    const error = this.state.invalidPhone ? <RegularError message={i18n('onboarding.phoneStep.invalidPatternError')} /> : null;
    const errorPhone = this.props.didVirtualMemberFail ? <SmallError message={i18n('onboarding.formValidation.invalidPhone')} /> : null;
    const loading = this.props.isVirtualMemberPending ? <Spinner /> : null;

    return (
      <div className="text-center">
        <div className={serverError}>
          <p className="form__serverError">{i18n('onboarding.formValidation.serverError')}</p>
        </div>
        <div className="row justify-content-center">
          <div className="col-8 col-sm-0 mb-5">
            <Title text={i18n('onboarding.phoneStepVirtualMember.welcome')} className="form__title" />
          </div>
        </div>
        <div className="row justify-content-center mb-5 mb-sm-0">
          <div className="col-8 col-sm-3 px-sm-4">
            <p className="form__description px-2 px-sm-0 font-weight-bold">{i18n('onboarding.phoneStep.text2')}</p>
          </div>
        </div>
        <form onSubmit={this.continue} className="form">
          <fieldset className="mb-5 pb-2 pb-sm-5">
            <input
              className={`form__input ${error || errorPhone ? 'form__input--error' : ''}`}
              type="tel"
              style={{ direction: 'ltr' }}
              onChange={this.setPhone}
              value={this.state.phoneNumber}
              placeholder={i18n('onboarding.phoneStep.phoneNumberPlaceholder')}
            />
            {errorPhone} {error}
          </fieldset>
          <Button text={i18n('onboarding.phoneStepVirtualMember.buttonText')} onClick={this.continue} />
        </form>
        {loading}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  virtualMemberDetails: getVirtualMemberDetails(state),
  didVirtualMemberFail: didVirtualMemberFail(state),
  isVirtualMemberPending: isVirtualMemberPending(state),
  isVirtualMemberSuccess: isVirtualMemberSuccess(state),
  contracts: state.sendContracts,
  smsStatus: state.sendSms,
  lang: state.lang
});

const mapDispatchToProps = dispatch => ({
  smsCreationPending: phone => dispatch(smsCreationPending(phone)),
  clearSms: () => dispatch(clearSms()),
  createVirtualMember: userData => dispatch(createVirtualMember(userData))
});

export default connect(mapStateToProps, mapDispatchToProps)(PhoneStep);



// WEBPACK FOOTER //
// ./src/components/Views/OnboardingVirtualMembers/Steps/PhoneStepVirtualMember.js